export const getMatrixItemsByPackagingFormat = (matrixItems, formatId) => {
    return matrixItems.filter((item) => {
        return item.packagingFormatId === formatId;
    });
};
//# sourceMappingURL=getMatrixItemsByPackagingFormat.js.map